import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gdb388grqx: FaireBrandEntity = {
  token: "b_gdb388grqx",
  type: "brand",
  name: "SubLuna",
  avatarUrl:
    "https://cdn.faire.com/fastly/14d1bd94e5f8bae560000870ed535bcb657291bd2dbd933ca8ad189c615926fe.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/facd9351e111b60e8ba85711cb7a633db306751fedcc37fb5b14522e5a0c08c6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/14d1bd94e5f8bae560000870ed535bcb657291bd2dbd933ca8ad189c615926fe.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/facd9351e111b60e8ba85711cb7a633db306751fedcc37fb5b14522e5a0c08c6.jpeg",
  location: "Omaha, NE, USA",
  minimumOrderDollars: 750,
  rating: 5,
  reviewCount: 6,
  isTopShop: true,
  isInsider: true,
  description:
    "SubLuna is an herbal wellness company focused on the journey back to nature and ourselves through premium herbal medicine, natural haircare, functional beverages, and their kid's herbal line, LunaKids.  The call to plant medicine symbolizes humanity's profound return to our origin and intuition, which is central to the SubLuna mission, and we’re honored to join you on this path. Our commitment to sovereignty and wellbeing is reflected in our products that harness the power of nature to promote wellness and vitality from within.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:56.988Z",
    importedBy: "entity-db-cli",
  },
};
